import { render, staticRenderFns } from "./contact-comp.vue?vue&type=template&id=b7d73280&scoped=true&"
import script from "./contact-comp.vue?vue&type=script&lang=js&"
export * from "./contact-comp.vue?vue&type=script&lang=js&"
import style0 from "./contact-comp.vue?vue&type=style&index=0&id=b7d73280&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d73280",
  null
  
)

export default component.exports